// extracted by mini-css-extract-plugin
module.exports = {"space":"Finalizados1_space__2ANlE"};